import { Factory } from '@infodata-group/inf-commons';
import { ReportTypeEnum } from '../../enum/report-type.enum';
import { BoReportMaterialInterface } from '../../interface/back-office/bo-report-material.interface';
import { AoReportDetail } from '../../model/report/ao-report-detail';
import { AoReportMaterial } from '../../model/report/ao-report-material';

export class ReportMaterialFactory implements Factory<AoReportMaterial> {
  build(o: BoReportMaterialInterface): AoReportMaterial {
    const report = new AoReportMaterial(o.id);
    report.type = ReportTypeEnum.material;
    report.date = o.date;
    report.materialId = o.materialId;
    report.materialLabel = o.materialLabel;
    report.tagMac = o.tagMac;
    report.tagLabel = o.tagLabel;
    report.totalTemps = o.totalTemps;
    report.totalChantier = o.totalChantier;
    report.totalDeplacement = o.totalDeplacement;
    report.totalTravail = o.totalTravail;
    report.totalPause = o.totalPause;
    report.vitesseMoyenne = isNaN(Number(o.vitesseMoyenne))
      ? 0
      : Number(o.vitesseMoyenne);
    report.vitesseMaximum = isNaN(Number(o.vitesseMaximum))
      ? 0
      : Number(o.vitesseMaximum);
    o.detail.forEach((d) => {
      const detail = new AoReportDetail();
      detail.heureDebut = d.heureDebut;
      detail.heureFin = d.heureFin;
      detail.duree = d.duree;
      detail.com = d.com;
      detail.position = d.position;
      detail.setChantier(d.chantier);
      detail.vehicule = d.vehicule;
      detail.latitude = d.latitude;
      detail.longitude = d.longitude;
      detail.grpChantier = d.grpChantier;
      report.detail.push(detail);
    });
    return report;
  }

  getApi(): string {
    return 'rapport/materiel/';
  }
}
